/* ============================================================
   VENTE FÊTE DU CANADA — countdown
   Drives any [data-cd-countdown] block. Reads:
     data-cd-end   ISO datetime the sale ends (e.g. 2026-07-08T00:00:00-04:00)
     data-cd-start optional ISO datetime the sale starts (pre-sale state)
   Writes into child [data-cd-days|hours|mins|secs].
   On expiry: hides the block and reveals optional [data-cd-ended].
   Idempotent: safe to load from multiple sections.
   ============================================================ */
(function () {
  if (window.__cdCountdownInit) return;
  window.__cdCountdownInit = true;

  function pad(n) { return (n < 10 ? "0" : "") + n; }

  function render(el, end) {
    var now = Date.now();
    var diff = end - now;
    if (diff <= 0) {
      el.setAttribute("hidden", "");
      var ended = el.parentNode && el.parentNode.querySelector("[data-cd-ended]");
      if (ended) ended.removeAttribute("hidden");
      return false;
    }
    if (diff < 21600000) { el.classList.add("cd-urgent"); } else { el.classList.remove("cd-urgent"); }
    var s = Math.floor(diff / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600);  s -= h * 3600;
    var m = Math.floor(s / 60);    s -= m * 60;
    set(el, "days", d);
    set(el, "hours", pad(h));
    set(el, "mins", pad(m));
    set(el, "secs", pad(s));
    return true;
  }

  function set(el, key, val) {
    var node = el.querySelector("[data-cd-" + key + "]");
    if (node) node.textContent = val;
  }

  function start(el) {
    var endAttr = el.getAttribute("data-cd-end");
    if (!endAttr) return;
    var end = Date.parse(endAttr);
    if (isNaN(end)) return;
    if (render(el, end) === false) return;
    var t = setInterval(function () {
      if (render(el, end) === false) clearInterval(t);
    }, 1000);
  }

  function init() {
    var blocks = document.querySelectorAll("[data-cd-countdown]");
    for (var i = 0; i < blocks.length; i++) start(blocks[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ============================================================
   DEAL OF THE DAY — auto-rotates by date, no daily management.
   Each [data-dotd-date="YYYY-MM-DD"] slot shows only on its day
   (America/Toronto). [data-dotd-default] shows when no date matches.
   ============================================================ */
(function () {
  if (window.__cdDotdInit) return;
  window.__cdDotdInit = true;

  function torontoToday() {
    try {
      return new Intl.DateTimeFormat("en-CA", {
        timeZone: "America/Toronto", year: "numeric", month: "2-digit", day: "2-digit"
      }).format(new Date());
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  }

  function initDotd() {
    var today = torontoToday();
    var roots = document.querySelectorAll("[data-dotd]");
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      var slots = root.querySelectorAll("[data-dotd-date]");
      var shown = false;
      for (var i = 0; i < slots.length; i++) {
        if (slots[i].getAttribute("data-dotd-date") === today) {
          slots[i].removeAttribute("hidden"); shown = true;
        } else {
          slots[i].setAttribute("hidden", "");
        }
      }
      if (!shown) {
        var def = root.querySelector("[data-dotd-default]");
        if (def) def.removeAttribute("hidden");
        else if (slots[0]) slots[0].removeAttribute("hidden");
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDotd);
  } else {
    initDotd();
  }
})();

/* ============================================================
   REVEAL ON SCROLL (gated by .cd-js so content never sticks hidden)
   ============================================================ */
(function () {
  if (window.__cdReveal) return; window.__cdReveal = true;
  function init() {
    var els = document.querySelectorAll(".cd-reveal");
    if (!("IntersectionObserver" in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add("cd-in");
      return;
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("cd-in"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px" });
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();

/* ============================================================
   RECENTLY VIEWED — captures sale-card clicks, renders a rail
   ============================================================ */
(function () {
  if (window.__cdRecent) return; window.__cdRecent = true;
  var KEY = "cd_recent";
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function record(card) {
    var h = card.getAttribute("data-cd-handle"); if (!h) return;
    var item = { h: h, t: card.getAttribute("data-cd-title"), i: card.getAttribute("data-cd-img"),
                 p: card.getAttribute("data-cd-price"), u: card.getAttribute("href") };
    var a = read().filter(function (x) { return x.h !== h; });
    a.unshift(item); write(a.slice(0, 12));
  }
  function renderRail() {
    var root = document.querySelector("[data-cd-recent]"); if (!root) return;
    var row = root.querySelector("[data-cd-recent-row]"); if (!row) return;
    var cur = (location.pathname.split("/products/")[1] || "").split("?")[0];
    var items = read().filter(function (x) { return x.h !== cur; });
    if (items.length < 2) return;
    row.innerHTML = "";
    items.slice(0, 8).forEach(function (x) {
      var a = document.createElement("a");
      a.className = "cd-recent__card"; a.href = x.u || ("/products/" + x.h);
      a.innerHTML = (x.i ? '<img src="' + x.i + '" alt="" loading="lazy">' : "") +
        '<div class="cd-recent__nm">' + (x.t || "") + "</div>" +
        (x.p ? '<div class="cd-recent__pr">' + x.p + "</div>" : "");
      row.appendChild(a);
    });
    root.removeAttribute("hidden");
  }
  function init() {
    document.addEventListener("click", function (e) {
      var c = e.target.closest(".cd-card[data-cd-handle]"); if (c) record(c);
    }, true);
    var pdp = document.querySelector("[data-cd-record][data-cd-handle]");
    if (pdp) record(pdp);
    renderRail();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();

/* ============================================================
   ANALYTICS — pushes click events to dataLayer if present (GA4/GTM)
   ============================================================ */
(function () {
  if (window.__cdTrack) return; window.__cdTrack = true;
  function init() {
    document.addEventListener("click", function (e) {
      var c = e.target.closest("[data-cd-handle], .cd-bar__cta, .cd-mtile, .cd-mosaic__anchor, .cd-nav__chip, .cd-spot__card");
      if (!c) return;
      var label = c.getAttribute("data-cd-title") || (c.textContent || "").trim().slice(0, 60);
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push({ event: "canada_day_click", cd_label: label });
      }
    }, true);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();

/* ============================================================
   CAROUSEL AFFORDANCE — visible arrow + "swipe for more" hint on
   any overflowing horizontal rail (mobile). For non-savvy users.
   ============================================================ */
(function () {
  if (window.__cdRails) return; window.__cdRails = true;
  var SEL = ".cd-tiles, .cd-flash__strip, .cd-spot, .cd-recent__row";
  function scrollable(r) { return r.scrollWidth > r.clientWidth + 4; }
  function upd(rail, next, hint) {
    var can = scrollable(rail);
    var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
    next.style.display = (can && !atEnd) ? "flex" : "none";
    hint.style.display = (can && rail.scrollLeft < 10) ? "block" : "none";
  }
  function setup(rail) {
    if (!rail.__cdWrap) {
      if (!scrollable(rail)) return;
      var wrap = document.createElement("div"); wrap.className = "cd-railwrap";
      rail.parentNode.insertBefore(wrap, rail); wrap.appendChild(rail);
      var next = document.createElement("button");
      next.type = "button"; next.className = "cd-rail-next";
      next.setAttribute("aria-label", "Voir plus d articles"); next.innerHTML = "›";
      var hint = document.createElement("div"); hint.className = "cd-rail-hint";
      hint.innerHTML = "Faites glisser pour voir plus ›";
      wrap.appendChild(next); wrap.appendChild(hint);
      next.addEventListener("click", function () {
        rail.scrollBy({ left: Math.round(rail.clientWidth * 0.85), behavior: "smooth" });
      });
      rail.addEventListener("scroll", function () { upd(rail, next, hint); }, { passive: true });
      rail.__cdWrap = { next: next, hint: hint };
    }
    upd(rail, rail.__cdWrap.next, rail.__cdWrap.hint);
  }
  function init() { var els = document.querySelectorAll(SEL); for (var i = 0; i < els.length; i++) setup(els[i]); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  var t; window.addEventListener("resize", function () { clearTimeout(t); t = setTimeout(init, 200); });
})();
